export default __webpack_public_path__ + "static/media/Hendrix_Hears_a_Sound_Cover.2b013d0e.jpeg";